import React from 'react';
import styled, {keyframes} from 'styled-components';
import {useTranslation} from 'react-i18next';
import packageJson from '../../package.json'; // Import package.json to access version

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const FooterContainer = styled.footer`
    background-color: ${props => props.theme.colors.secondary};
    color: ${props => props.theme.colors.background};
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    z-index: 1;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }
`;

const FooterSection = styled.div`
    flex: 1;
    min-width: 200px;
    animation: ${fadeIn} 0.5s ease-out forwards;
    animation-delay: ${props => props.delay}s;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: center;

    @media (max-width: 768px) {
        min-width: 100%;
    }
`;

const FooterTitle = styled.h3`
    color: ${props => props.theme.colors.primary};
    font-size: 1.2rem;
    margin-bottom: 10px;
`;

const FooterText = styled.p`
    font-size: 14px;
    margin: 5px 0;
`;

const FooterLink = styled.a`
    color: ${props => props.theme.colors.background};
    text-decoration: none;
    transition: color 0.3s ease;
    font-size: 14px;

    &:hover {
        color: ${props => props.theme.colors.primary};
    }
`;

const Footer = ({rentUser, config}) => {
    const {t} = useTranslation();

    return (
        <FooterContainer>
            <FooterSection delay={0}>
                <FooterTitle>{rentUser?.name || t('welcome')}</FooterTitle>
                <FooterLink href="https://locemsolutions.com" target="_blank" rel="noopener noreferrer">
                    {t('managedBy', {name: 'LoceM Solutions © ' + new Date().getFullYear()})}
                </FooterLink>
                <FooterText>
                    v{packageJson.version}
                </FooterText>
            </FooterSection>
            <FooterSection delay={0.2}>
                <FooterTitle>{t('contactUs')}</FooterTitle>
                <FooterText>
                    <strong>{t('address')}</strong>{' '}
                    <br/>
                    {rentUser?.city}, {rentUser?.street}
                </FooterText>
                <FooterText>
                    <strong>{t('email')}</strong>{' '}
                    <br/>
                    <FooterLink href={`mailto:${rentUser?.contacts?.email || ''}`}>
                        {rentUser?.contacts?.email || 'N/D'}
                    </FooterLink>
                </FooterText>
                <FooterText>
                    <strong>{t('phone')}</strong>{' '}
                    <br/>
                    <FooterLink href={`tel:${rentUser?.contacts?.phoneNumber || ''}`}>
                        {rentUser?.contacts?.phoneNumber || 'N/D'}
                    </FooterLink>
                </FooterText>
                <FooterText>
                    <strong>{t('vatNumber', {defaultValue: 'Partita IVA'})}</strong>{' '}
                    <br/>
                    {rentUser?.vatNumber || 'N/D'}
                </FooterText>
            </FooterSection>
        </FooterContainer>
    );
};

export default Footer;
